import React from 'react';

const remindersData = [
  { reminder: "Advance Directive Discussion", due: "Feb 15, 2020" },
  { reminder: "Human Papillomavirus (HPV)", due: "Feb 15, 2020" },
  { reminder: "Influenza Immunization", due: "DUE NOW" },
  { reminder: "Pneumococcal Conjugate Vaccine (PCV15/PCV20)", due: "Feb 15, 2020" },
  { reminder: "Obesity Screen", due: "DUE NOW" },
  { reminder: "COVID-19 Immunization", due: "Feb 15, 2020" },
  { reminder: "Sexual Orientation", due: "DUE NOW" },
  { reminder: "Info Only: VA Video Connect Capable", due: "Feb 15, 2020" },
  { reminder: "Psychosocial Stress/Whole Health (NAP)", due: "DUE NOW" },
  { reminder: "Toxic Exposure Screening", due: "DUE NOW" },
  { reminder: "My HealtheVet Education", due: "Dec 14, 2021" }
];



const ClinicalRemainders = () => {
  return (
    <div style={{ borderRadius: 4, padding: 8, maxWidth: 600 }}>
      <div style={{ display: "flex", fontWeight: "bold", padding: "6px 0"}}>
        <div style={{ flex: 2, paddingLeft: 12}}>Reminder</div>
        <div style={{ flex: 1 }}>Due Date</div>
      </div>
      <ul style={{ 
        listStyle: 'disc', 
        margin: 0, 
        padding: '0 0 0 20px',
        backgroundColor: '#fff'
      }}>
        {remindersData.map((row, idx) => (
          <li key={idx} style={{ 
            display: "flex", 
            listStyleType: 'disc',
            marginBottom: '4px'
          }}>
            <div style={{ flex: 2, color: "#1a73e8", fontWeight: "bold",fontSize:'12px' }}>{row.reminder}</div>
            <div style={{ flex: 1, color: "#1a73e8", fontWeight: "bold" ,fontSize:'12px'}}>{row.due}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};



export default ClinicalRemainders;
